// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"1eda27bc","528":"0350c1a2","562":"c07c7f1a","666":"9176bf6f","941":"a21a6ee6"}[chunkId] + ".js";
};